import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import ThemeProvider from "./contextApi/ThemeContext";
import { Provider } from "react-redux";
import store from "./redux/store";
import { BrowserRouter } from "react-router";
import { TourProvider } from "@reactour/tour";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <TourProvider steps={[]}
        padding={8}
        disableInteraction={false}
        styles={{
          popover: (base) => ({
            ...base,
            borderRadius: 14,       
            boxShadow: "0 14px 40px rgba(0,0,0,0.18)",
            padding: 14,
            maxWidth: 380,
            fontSize:"14px"
          }),
          maskWrapper: (b) => ({ ...b, color: "rgba(0,0,0,0.6)" }),
          maskArea: (b) => ({ ...b, rx: 10, ry: 10 }), 
          close: () => ({ display: "none" }),
          badge: (b) => ({ ...b, background: "#7c3aed" }),
        }}>
        <ThemeProvider>
          <Provider store={store}>
            <App />
          </Provider>
        </ThemeProvider>
      </TourProvider>
    </BrowserRouter>
  </React.StrictMode>
);
